import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { localizeType } from '../../commonType';
import { Offer } from '../../features/offerSearch/types';
import { RootState } from '../../redux/rootReducer';
import { LOC } from '../../util/strings';
import DopInformation from '../common/DopInformation/DopInformation';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import './ViewDestination.scss';

interface ViewDestinationType {
  localize: localizeType;
  offer: Offer;
  onViewOfferClicked: any;
}
const ViewDestination: FC<ViewDestinationType> = (props: ViewDestinationType): ReactElement => {
  const { localize, offer, onViewOfferClicked } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const customerExcludedStateCode = offerDetails.customerExcludedStateCode;
  const modeLoc = offerDetails.searchParameter.mode === LOC ? true : false;
  const prospectStateSelected = modeLoc ? (customerExcludedStateCode ? false : true) : false;
  const property = offer.property;
  const address = `${property!.city ? property!.city : ''}, ${property!.stateProvince ? property!.stateProvince : ''}`;
  const formattedAddress = address
    .split(',')
    .filter((x) => x && x.trim().length > 0)
    .join(',')
    .trim();
  const premiums =
    offer && offer.premiums
      ? offer?.premiums
          .filter((x) => x !== null)
          .join(', ')
          .trim()
      : '';
  return (
    <div className="propertyWrapper">
      {offer.includeOffer ? (
        <>
          <div className="row propertyDisplay">
            <div className="col-sm-3 leftPad">
              <img src={property?.heroImg} className="fullWidth destination-image" alt={property?.name} />
            </div>
            <div className="col-sm-6 verticalAlign destination-tile">
              <div>
                <h5 className="propertHeading">{property?.name}</h5>
                <p>{formattedAddress}</p>
                <div>
                  {localize('preview-sales-engine.static-content.copy.select-offer-page.days-nights', [
                    offer.offerDays ? offer.offerDays : '',
                    offer.offerNights ? offer.offerNights : '',
                  ])}
                  <div className="vr"></div>
                  {localize('preview-sales-engine.static-content.copy.select-offer-page.max-guests')}{' '}
                  {offer.offerMaxGuest}
                </div>
                <div>{offer.offerDescription}</div>
                <div>
                  {premiums ? (
                    <p>
                      <ParseHtml
                        htmlInput={`${localize(
                          'preview-sales-engine.static-content.copy.prospects.plustext',
                        )} ${premiums}`}
                      ></ParseHtml>
                    </p>
                  ) : (
                    <></>
                  )}
                  <p> </p>
                </div>
                <ParseHtml
                  htmlInput={
                    localize
                      ? localize(
                          'preview-sales-engine.static-content.copy.select-destination-page.cost-per-stay',
                          offer.minimumStartingCost,
                        )
                      : ''
                  }
                />
              </div>
            </div>
            <div className="col-sm-3 rightAlign">
              <div>
                <button
                  className="roomTypeSelectButton"
                  disabled={prospectStateSelected}
                  onClick={(e) => onViewOfferClicked()}
                >
                  {localize
                    ? localize(
                        'preview-sales-engine.static-content.copy.select-destination-page.select-destination-button',
                      )
                    : ''}
                </button>
                <DopInformation dopCodeDetails={offer.dopCodeDetails} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default withLocalization(ViewDestination);
